import { useEffect, useState } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import { api } from '../services/api.js'
import { useAuthStore } from '../stores/auth.js'

export default function InvitePage() {
  const { token } = useParams()
  const navigate = useNavigate()
  const { token: authToken } = useAuthStore()
  const [invite, setInvite] = useState(null)
  const [loading, setLoading] = useState(true)
  const [accepting, setAccepting] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    api.get(`/invites/${token}`)
      .then(setInvite)
      .catch(() => setError('This invite link is invalid or has expired.'))
      .finally(() => setLoading(false))
  }, [token])

  async function accept() {
    setAccepting(true)
    try {
      const res = await api.post(`/invites/${token}/accept`)
      navigate(`/tree/${res.tree_id}`)
    } catch (err) {
      setError(err.message || 'Failed to accept invite')
      setAccepting(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--warm-white)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '2rem',
    }}>
      <div style={{
        background: 'white', borderRadius: '12px',
        border: '1px solid var(--border)', padding: '2.5rem',
        maxWidth: '420px', width: '100%', textAlign: 'center',
      }}>
        <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>🌳</div>

        {loading ? (
          <p style={{ color: 'var(--text-muted)' }}>Loading invite…</p>
        ) : error ? (
          <>
            <h2 style={{ fontSize: '1.1rem', marginBottom: '0.75rem' }}>Invite not found</h2>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>{error}</p>
            <Link to="/" className="btn btn-primary">Go to Genealogic</Link>
          </>
        ) : (
          <>
            <h2 style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>
              You're invited to join a family tree
            </h2>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', marginBottom: '0.25rem' }}>
              <strong>{invite.invited_by_name}</strong> invited you to
            </p>
            <p style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text)', marginBottom: '0.25rem' }}>
              {invite.tree_name}
            </p>
            <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '2rem' }}>
              as {invite.role === 'editor' ? 'an editor (can view and edit)' : 'a viewer'}
            </p>

            {authToken ? (
              <button
                className="btn btn-primary"
                style={{ width: '100%' }}
                onClick={accept}
                disabled={accepting}
              >
                {accepting ? 'Joining…' : 'Accept invitation'}
              </button>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <Link
                  to={`/register?invite=${token}`}
                  className="btn btn-primary"
                  style={{ textAlign: 'center' }}
                >
                  Create account to accept
                </Link>
                <Link
                  to={`/login?invite=${token}`}
                  className="btn btn-ghost"
                  style={{ textAlign: 'center' }}
                >
                  Sign in to accept
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}
